/**
 * In-memory store for Cognito tokens (serviceToken, idToken).
 * Tokens are not persisted to localStorage to reduce XSS exposure.
 */
import { Auth } from 'aws-amplify';

let serviceToken: string | null = null;
let idToken: string | null = null;

export const getServiceToken = (): string | null => serviceToken;
export const getIdToken = (): string | null => idToken;

export const setCognitoSession = (newServiceToken?: string | null, newIdToken?: string | null) => {
    serviceToken = newServiceToken ?? null;
    idToken = newIdToken ?? null;
};

export const clearCognitoSession = () => {
    serviceToken = null;
    idToken = null;
};

// Rehydrate from Amplify's persisted session when memory was wiped (e.g. full page reload).
export const resolveServiceToken = async (): Promise<string | null> => {
    if (serviceToken) return serviceToken;
    try {
        const session = await Auth.currentSession();
        const accessToken = session.getAccessToken().getJwtToken();
        const newIdToken = session.getIdToken().getJwtToken();
        setCognitoSession(accessToken, newIdToken);
        return accessToken;
    } catch {
        return null;
    }
};
